/**
 * Invoice Ninja (https://invoiceninja.com).
 *
 * @link https://github.com/invoiceninja/invoiceninja source repository
 *
 * @copyright Copyright (c) 2022. Invoice Ninja LLC (https://invoiceninja.com)
 *
 * @license https://www.elastic.co/licensing/elastic-license
 */

export const aliases: Record<string, string> = {
  item: 'product_key',
  service: 'product_key',
  description: 'notes',
  unit_cost: 'cost',
  rate: 'cost',
  hours: 'quantity',
};
